import { EditIcon, EyeIcon, PinIcon, UnPinIcon } from "@root/assets/icons";
import DeleteIcon from "@root/assets/icons/delete-02.svg";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { DELETE, EDIT, VISIBILITY, PIN } from "@root/constants";
import { formatDateToISO } from "@root/utils/date-helper";
import { PinColorIcon } from "@root/assets/icons/PinColorIcon";
import { NonVisiableIcon } from "@root/assets/icons/NonVisiableIcon";

export const TableColumns = (handleActions: any, t: any) => {
  return [
    {
      cell: (info: any) => (
        <Box>
          {info?.row?.original?.pin ? (
            <Flex marginLeft={"-10px"} alignItems={"center"} gap={"8px"}>
              <PinColorIcon />{" "}
              <Text fontWeight={400} fontSize={"11px"} textColor={"#1819B4"}>
                {t("notice.pinnedByYou")}
              </Text>{" "}
            </Flex>
          ) : (
            ""
          )}
          <Text>{info?.row?.original?.title}</Text>
        </Box>
      ),
      header: t("notice.titlea"),
    },
    {
      cell: (info: any) => (
        <Box
          maxW="450px"
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {info?.row?.original?.description || ""}
        </Box>
      ),
      header: t("notice.content"),
    },

    {
      cell: (info: any) => formatDateToISO(info?.row?.original?.createdAt),
      header: t("notice.datePosted"),
    },
    {
      cell: (info: any) => info?.row?.original?.noticeType?.name,
      header: t("notice.type"),
    },
    {
      cell: (info: any) => (
        <Flex gap={"14px"}>
          <Flex
            gap={"8px"}
            cursor={"pointer"}
            onClick={() => handleActions(VISIBILITY, info?.row?.original)}
            alignItems={"center"}
          >
            {info?.row?.original?.isPublish ? <EyeIcon /> : <NonVisiableIcon />}
          </Flex>
          <Flex
            gap={"8px"}
            cursor={"pointer"}
            onClick={() =>
              handleActions(PIN, {
                ...info?.row?.original,
                pin: !info?.row?.original?.pin,
              })
            }
          >
            {info?.row?.original?.pin ? <UnPinIcon /> : <PinIcon />}
          </Flex>
          <Flex
            gap={"8px"}
            cursor={"pointer"}
            onClick={() => handleActions(EDIT, info?.row?.original)}
            alignItems={"center"}
          >
            <EditIcon color={"#676879"} />
          </Flex>
          <Flex
            gap={"8px"}
            cursor={"pointer"}
            onClick={() => handleActions(DELETE, info?.row?.original)}
          >
            <Image src={DeleteIcon} width={18} />
          </Flex>
        </Flex>
      ),
      header: t("notice.actions"),
    },
  ];
};
